/* eslint-disable spire/fenced-imports */
/* eslint-disable camelcase */
import { getUrl } from "@insite/client-framework/ServerSideRendering";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { css } from "styled-components";
import { withCoveoHooks, HasCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { useDispatch, useSelector } from "react-redux";
import { CoveoActions } from "@NA/Store/Reducer/CoveoCommerceReducer";

type Props = WidgetProps & HasCoveoHooks;

export interface ProductListCardListStyles {
    centeringWrapper?: InjectableCss;
}

export const listStyles: ProductListCardListStyles = {
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
};

const styles = listStyles;

const CoveoPagination = ({ summary, pagination }: Props) => {
    const dispatch = useDispatch();
    const total = summary.state?.totalNumberOfProducts ?? 0;
    const start = summary.state?.firstProduct ?? 0;
    const end = summary.state?.lastProduct ?? 0;
    const isLoaded = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.coveoCommerce.loadedCompletePLP,
    );

    const getServerUrl = () => {
        const url = getUrl();
        const searchParams = new URLSearchParams(url?.searchParams.toString());
        searchParams.set("page", String(pagination?.state?.page + 1));
        return `${url?.pathname}?${searchParams.toString()}`;
    };

    return end > 0 && end !== total ? (
        <>
            {isLoaded && (
                <>
                    <Typography
                        style={{
                            display: "Flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "35px",
                        }}
                    >
                        {`Showing ${start} - ${end} of ${total}`}
                    </Typography>
                    {IS_SERVER_SIDE ? (
                        <Link
                            href={getServerUrl()}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Button
                                variant="secondary"
                                style={{
                                    margin: "10px auto",
                                    display: "block",
                                    background: "rgb(0, 106, 227)",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                }}
                                onClick={() => {}}
                            >
                                Show More Products
                            </Button>
                        </Link>
                    ) : (
                        <Button
                            onClick={() => pagination.methods?.fetchMoreProducts()}
                            variant="secondary"
                            style={{
                                margin: "10px auto",
                                display: "block",
                                background: "rgb(0, 106, 227)",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "bold",
                            }}
                        >
                            Show More Products
                        </Button>
                    )}
                </>
            )}
        </>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: withCoveoHooks(CoveoPagination),
    definition: {
        group: "Product List",
        displayName: "Coveo Load More",
    },
};
export default widgetModule;


